import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Profile } from '@df/interfaces';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PeopleService } from '@app/core/services';
import { HandlerService } from '@app/_services/handler.service';

@Component({
    selector: 'app-password-profile-settings',
    templateUrl: './password-profile-settings.component.html',
    styleUrls: ['./password-profile-settings.component.scss']
})
export class PasswordProfileSettingsComponent implements OnInit {
    profile: Profile;
    form: FormGroup;
    hidePassword = true;
    hideNewPassword = true;
    hideNewPasswordCheck = true;

    constructor(
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private peopleService: PeopleService,
        private handlerService: HandlerService
    ) {}

    ngOnInit(): void {
        this.route.data.subscribe(data => {
            this.profile = data['profile'].data;
        });

        this.form = this.fb.group({
            password: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(30)]],
            newPassword: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(30)]],
            newPasswordCheck: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(30)]]
        });
    }

    onSubmit(): void {
        const formData = {
            old_password: this.form.value.password,
            new_password: this.form.value.newPassword
        };

        this.peopleService.updatePassword(formData).subscribe(resp => {
            this.handlerService.checkErrors(resp);
            if (resp.success) {
                this.handlerService.successMsg('Пароль успешно изменен');
            }
        });

        this.form.patchValue({
            password: '',
            newPassword: '',
            newPasswordCheck: ''
        });
    }
}
